<template>
  <div>
    <report-header @generate="generate" @filterChanged="filterChanged"
    @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd"
    :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>
    <basic-table
      :items="reportCharges"
      :fields="reportChargesFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
    :totalRows="totalRows" :perPage="perPage"
    v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    editItem: null
  },
  data () {
    return {
      reportCharges: [],
      reportChargesFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'user_id', label: this.$i18n.t('User ID'), sortable: true},
        {key: 'user_login', label: this.$i18n.t('User login'), sortable: true},
        {key: 'session_id', label: this.$i18n.t('Session id'), sortable: true},
        {key: 'customer_cost', label: this.$i18n.t('Customer cost'), sortable: true},
        {key: 'customer_cost_with_tax', label: this.$i18n.t('Customer cost with tax'), sortable: true},
        {key: 'supplier_cost', label: this.$i18n.t('Supplier cost'), sortable: true},
        {key: 'supplier_cost_with_tax', label: this.$i18n.t('Supplier cost with tax'), sortable: true},
        {key: 'calling_station_id', label: this.$i18n.t('Calling number'), sortable: true},
        {key: 'called_station_id', label: this.$i18n.t('Called number'), sortable: true},
        {key: 'duration', label: this.$i18n.t('Duration'), sortable: true},
        {key: 'charge_date', label: this.$i18n.t('Charge date'), sortable: true},
        {key: 'charge_duration', label: this.$i18n.t('Session time(rouded off)'), sortable: true}
      ],
      isGenerateDisabled: false,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      currentTab: 1,
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async generate () {
      this.isGenerateDisabled = true
      let generate = {
        numDateEnd: 0,
        numDateStart: 0,
        supplier_id: 0
      }
      generate.numDateEnd = Number(this.dateEnd) / 1000
      if (generate.numDateEnd > 2147483647) generate.numDateEnd = 2147483647
      generate.numDateStart = Number(this.dateStart) / 1000
      if (generate.numDateStart > 2147483647) generate.numDateStart = 2147483647
      generate.supplier_id = this.editItem.id
      let reportCharges = await this.$store.dispatch('Settings/GET_REPORT_CHARGES', generate)
      this.reportCharges = reportCharges.data
      for (let el of this.reportCharges) {
        el.charge_date = moment(Number(el.charge_date) * 1000).format('MM-DD-YYYY')
      }
      this.loadDone()
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/telephony/telephoneOperators/reportCharges.vue